import { render, staticRenderFns } from "./CASeal.vue?vue&type=template&id=45c154d8&scoped=true&"
import script from "./CASeal.vue?vue&type=script&lang=js&"
export * from "./CASeal.vue?vue&type=script&lang=js&"
import style0 from "./CASeal.vue?vue&type=style&index=0&id=45c154d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c154d8",
  null
  
)

export default component.exports